import React, { useEffect, useState, useContext, userEffect } from "react";
import { useHistory } from "react-router-dom";
import { UserContext, SnackbarContext, ModalContext } from "../../contexts";
import { useInput, usePagination } from "../../hooks";
import {
  FormInput,
  Button,
  TablePoint,
  Paging,
  TableCalculate,
} from "../../components";
import API from "../../api";
import Util from "../../util";
import { useTranslation } from "react-i18next";

export const MypageCalculatePage = (props) => {
  const { t } = useTranslation(); // useTranslation 훅을 사용하여 t 함수를 가져옴

  const history = useHistory();
  const { updateSnackbar } = useContext(SnackbarContext);
  const { userInfo, refreshUserInfo } = useContext(UserContext);
  const [list, setList] = useState(null);
  const [
    page,
    totalPage,
    totalCount,
    onPageChange,
    setPage,
    setTotalPage,
    setTotalCount,
  ] = usePagination(1, 10);
  const [loading, setLoading] = useState(false);
  const {
    modalData,
    updateModalOpen,
    updateModalData,
    closeModal,
  } = useContext(ModalContext);

  useEffect(() => {
    refreshUserInfo();
  }, []);

  console.log("userInfo", userInfo);
  useEffect(() => {
    requsetList();
  }, [page]);

  useEffect(() => {
    if (
      modalData &&
      modalData.type &&
      modalData.type === "mypage-calculate-refresh"
    ) {
      console.log("modalData", modalData);
      requsetList(1);
      updateModalData({ type: "" });
      refreshUserInfo();
    }
  }, [modalData]);
  const requsetList = (init_page) => {
    setLoading(true);
    let params = {
      page: init_page ? init_page : page,
      limit: 10,
    };

    API.Member.GetCalculte(params).then(
      (res) => {
        let result = res.data;
        console.log("Member.GetPoint", result);
        setList(result.items);
        setTotalPage(result.meta.totalPages);
        setTotalCount(result.meta.totalCount);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        updateSnackbar({
          type: "error",
          open: true,
          message: err.data.message,
        });
      }
    );
  };

  if (!userInfo) {
    return null;
  }

  return (
    <article className="mypage-point-page calculate">
      <section className="title__box">
        <h3>
          {t("mypage.calculate.title_point")} :{" "}
          <b>{Util.Form.formatNumber(userInfo.point)}</b>
        </h3>
        <h3>
          {t("mypage.calculate.title_ing")} :{" "}
          <b>{Util.Form.formatNumber(userInfo.lockPoint)}</b>
        </h3>
        <h3>
          {t("mypage.calculate.title_complete")} :{" "}
          <b>{Util.Form.formatNumber(userInfo.calculatePoint)}</b>
        </h3>
        <Button
          onClick={() => {
            updateModalData({
              type: "calculate",
              title: t("mypage.calculate.confirm.title"),
              content: t("mypage.calculate.confirm.content"),
              guide: t("mypage.calculate.confirm.guide"),
            });
            updateModalOpen(true);
          }}
          label={t("mypage.calculate.button.request")}
        ></Button>
      </section>

      <section className="banner__box">
        <header>
          <span>{t("mypage.calculate.guide.title")} : </span>
        </header>
        <div className="value__box">
          <span>{t("mypage.calculate.guide.desc")}</span>
        </div>
      </section>
      <section className="table__box">
        <TableCalculate data={list} loading={loading}></TableCalculate>
      </section>

      <section className="page__box">
        <Paging
          page={page}
          totalPage={totalPage}
          onChange={onPageChange}
        ></Paging>
      </section>
    </article>
  );
};
